import { db } from '../../firebase';

export const startEditBidState = (bidId, state) => {
  return (dispatch) => db.updateBidState(bidId, state);
};



// WEBPACK FOOTER //
// ./src/store/actions/bidStatus.js